import React, { useState, useEffect } from 'react';
import { Layout, Menu, Button, Avatar, Dropdown } from 'antd';
import { 
  MenuFoldOutlined, 
  MenuUnfoldOutlined, 
  LogoutOutlined,
  UserOutlined,
  SettingOutlined 
} from '@ant-design/icons';
import { FaTachometerAlt, FaEnvelopeOpenText, FaQrcode } from 'react-icons/fa';
import { useNavigate, Outlet, useLocation } from 'react-router-dom';
import logo from '../assets/img/invite.png';

const { Header, Sider, Content } = Layout;

const MenuLayout_QRInvite = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [selectedKey, setSelectedKey] = useState(['1']);
  const [nome, setNome] = useState('');

  const navigate = useNavigate();
  const location = useLocation();


  useEffect(() => {
         const storedToken = localStorage.getItem('token');
      const token = storedToken ? JSON.parse(storedToken) : null;
     setNome(token.nome);

 
 
  }, []);







  // Logout
  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("loginTime");
    localStorage.removeItem("perfil");
    window.location.href = "/";
  };

  // Verifica expiração da sessão (1h)
  useEffect(() => {
    const loginTime = parseInt(localStorage.getItem("loginTime"), 10) || Date.now();
    const now = Date.now();
    const expired = now - loginTime > 3600000;

    if (expired) logout();
    else {
      const remaining = 3600000 - (now - loginTime);
      const timeout = setTimeout(logout, remaining);
      return () => clearTimeout(timeout);
    }
  }, []);

  // Atualiza item selecionado conforme rota
  useEffect(() => {
    if (location.pathname.includes('/dashboard')) setSelectedKey(['1']);
    else if (location.pathname.includes('/convites')) setSelectedKey(['2']);
    else setSelectedKey([]);
  }, [location.pathname]);

  const menuItems = [
   /* {
      key: '1',
      icon: <FaTachometerAlt className="menu-icon" />,
      label: 'Dashboard',
      onClick: () => navigate('/dashboard'),
    },*/
    {
      key: '2',
      icon: <FaEnvelopeOpenText className="menu-icon" />,
      label: 'Convites',
      onClick: () => navigate('/convites'),
    },
  ];

  const userMenuItems = [
  
 
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Terminar Sessão',
      onClick: logout,
    },
  ];

  return (
    <Layout style={{ minHeight: '100vh', background: '#f8f9fa' }}>
      {/* Barra lateral */}
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        width={280}
        style={{
          background: 'linear-gradient(180deg, #c79a3f 0%, #f4d58d 100%)',
          position: 'fixed',
          height: '100vh',
          left: 0,
          top: 0,
          bottom: 0,
          zIndex: 100,
          display: 'flex',
          flexDirection: 'column',
          boxShadow: '4px 0 20px rgba(0,0,0,0.1)',
        }}
      >
        {/* Logo */}
        <div className="logo-container">
          <div className="logo-content">
            <FaQrcode className="logo-icon" />
            {!collapsed && (
              <div className="logo-text">
                <span className="logo-title">QR Invite</span>
                <span className="logo-subtitle">Sistema de Convites</span>
              </div>
            )}
          </div>
        </div>

        {/* Menu lateral */}
        <div className="menu-container">
          <Menu
            mode="inline"
            selectedKeys={selectedKey}
            items={menuItems}
            className="custom-menu"
          />
        </div>

        {/* Footer do menu */}
        {!collapsed && (
          <div className="menu-footer">
            <div className="menu-footer-content">
              <span>QR INVITE</span>
              <span style={{ fontSize: '12px', opacity: 0.8 }}>v1.0.0</span>
            </div>
          </div>
        )}
      </Sider>

      {/* Conteúdo principal */}
      <Layout
        style={{
          marginLeft: collapsed ? 80 : 280,
          transition: 'all 0.3s cubic-bezier(0.2, 0, 0, 1)',
        }}
      >
        {/* Cabeçalho */}
        <Header className="main-header">
          <div className="header-left">
            <Button
              type="text"
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={() => setCollapsed(!collapsed)}
              className="menu-toggle-btn"
            />
            <div className="breadcrumb">
              {selectedKey[0] === '1' && 'Dashboard'}
              {selectedKey[0] === '2' && 'Gestão de Convites'}
            </div>
          </div>

          <div className="header-right">
            <Dropdown
              menu={{ items: userMenuItems }}
              trigger={['click']}
              placement="bottomRight"
            >
              <div className="user-profile">
                <Avatar 
                  size="default" 
                  icon={<UserOutlined />}
                  className="user-avatar"
                />
                <span className="user-name">{nome}</span>
              </div>
            </Dropdown>
          </div>
        </Header>

        {/* Conteúdo interno */}
        <Content className="main-content">
          <div className="content-wrapper">
            <Outlet />
          </div>
        </Content>
      </Layout>

      {/* Estilos */}
      <style jsx global>{`
        /* Logo styles */
        .logo-container {
          padding: 24px 20px;
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
          margin-bottom: 16px;
        }

        .logo-content {
          display: flex;
          align-items: center;
          justify-content: ${collapsed ? 'center' : 'flex-start'};
          color: white;
          gap: 12px;
        }

        .logo-icon {
          font-size: 28px;
          color: white;
        }

        .logo-text {
          display: flex;
          flex-direction: column;
        }

        .logo-title {
          font-size: 20px;
          font-weight: 700;
          line-height: 1.2;
        }

        .logo-subtitle {
          font-size: 12px;
          opacity: 0.9;
          font-weight: 400;
        }

        /* Menu styles */
        .menu-container {
          flex: 1;
          padding: 0 12px;
        }

        .custom-menu {
          background: transparent !important;
          border: none !important;
        }

        .custom-menu .ant-menu-item {
          height: 48px !important;
          margin: 4px 0 !important;
          border-radius: 12px !important;
          display: flex !important;
          align-items: center !important;
          color: white !important;
          font-weight: 500 !important;
          transition: all 0.3s ease !important;
        }

        .custom-menu .ant-menu-item:hover {
          background: rgba(255, 255, 255, 0.15) !important;
          transform: translateX(4px);
        }

        .custom-menu .ant-menu-item-selected {
          background: white !important;
          color: #c79a3f !important;
          font-weight: 600 !important;
          box-shadow: 0 4px 12px rgba(199, 154, 63, 0.2);
        }

        .custom-menu .ant-menu-item-selected .menu-icon {
          color: #c79a3f !important;
        }

        .menu-icon {
          font-size: 18px !important;
          margin-right: 12px;
        }

        /* Menu footer */
        .menu-footer {
          padding: 20px;
          border-top: 1px solid rgba(255, 255, 255, 0.1);
          margin-top: auto;
        }

        .menu-footer-content {
          color: white;
          font-size: 11px;
          text-align: center;
          opacity: 0.7;
          display: flex;
          flex-direction: column;
          gap: 4px;
        }

        /* Header styles */
        .main-header {
          background: white !important;
          padding: 0 24px !important;
          display: flex;
          align-items: center;
          justify-content: space-between;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
          height: 64px;
          position: sticky;
          top: 0;
          z-index: 99;
        }

        .header-left {
          display: flex;
          align-items: center;
          gap: 16px;
        }

        .menu-toggle-btn {
          border: none !important;
          box-shadow: none !important;
          font-size: 18px;
          color: #c79a3f !important;
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 8px;
          transition: all 0.3s ease;
        }

        .menu-toggle-btn:hover {
          background: #f8f8f8 !important;
        }

        .breadcrumb {
          font-size: 16px;
          font-weight: 600;
          color: #262626;
        }

        .header-right {
          display: flex;
          align-items: center;
        }

        .user-profile {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 8px 12px;
          border-radius: 8px;
          cursor: pointer;
          transition: background 0.3s ease;
        }

        .user-profile:hover {
          background: #f8f8f8;
        }

        .user-avatar {
          background: #c79a3f;
        }

        .user-name {
          font-weight: 500;
          color: #262626;
        }

        /* Content styles */
        .main-content {
          margin: 24px;
          min-height: calc(100vh - 112px);
        }

        .content-wrapper {
          background: white;
          border-radius: 16px;
          padding: 24px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
          min-height: 100%;
          border: 1px solid #f0f0f0;
        }

        /* Responsive */
        @media (max-width: 768px) {
          .main-header {
            padding: 0 16px !important;
          }
          
          .main-content {
            margin: 16px;
          }
          
          .content-wrapper {
            padding: 16px;
            border-radius: 12px;
          }
          
          .user-name {
            display: none;
          }
        }
      `}</style>
    </Layout>
  );
};

export default MenuLayout_QRInvite;